import React from 'react';

import { bool, string } from 'prop-types';

import SvgIcon from '@mui/material/SvgIcon';

const SchoolinksLogo = props => {
  const { fill, color, wordmark } = props;

  if (wordmark) {
    return (
      <SvgIcon
        viewBox="0 0 1200 190"
        style={{ fill: fill || color }}
        {...props}
      >
        <path
          d="M1064.96 17.6631C1050.13 43.3228 1055.13 78.5664 1078.79 97.6345C1092.89 109 1106.45 120.996 1120.23 132.736L1105.6 149.243L1105.59 149.237C1094.65 139.908 1063.76 113.843 1063.85 113.921C1032.01 86.6396 1025.53 41.537 1045.56 6.87594L1064.96 17.6631Z"
          fill="#1E1A12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1154.47 12.6271L1198.55 47.1538L1184.63 64.2435L1140.36 29.5638L1139.95 29.228C1128.66 19.4872 1111.5 20.5732 1101.53 31.6797C1091.61 42.7363 1092.71 59.5481 1104 69.3266L1145.68 104.593L1145.76 104.664C1166.29 122.385 1168.37 153.037 1150.27 173.211C1132.2 193.347 1100.95 195.385 1080.38 177.632L1080.3 177.557L1036.34 138.816C1036.34 138.816 1051.24 122.548 1051.24 122.548L1095.15 161.248C1106.44 170.952 1123.58 169.856 1133.53 158.763C1143.45 147.706 1142.36 130.894 1131.07 121.115L1089.39 85.849L1089.3 85.7779C1068.77 68.0577 1066.7 37.4056 1084.8 17.2316C1102.8 -2.83559 1133.9 -4.92898 1154.47 12.6271Z"
          fill="#1E1A12"
        />
        <path
          d="M1169.19 172.986C1184.02 147.326 1179.02 112.082 1155.36 93.0143C1141.26 81.6489 1113.92 57.9127 1113.92 57.9127L1128.55 41.4053L1128.55 41.4113C1139.5 50.7408 1170.39 76.8057 1170.29 76.7273C1202.13 104.009 1208.62 149.112 1188.58 183.773L1169.19 172.986Z"
          fill="#1E1A12"
        />
        <path
          d="M619.697 32.7886C619.697 22.7466 627.875 14.1216 638.231 14.1216C648.662 14.1216 656.979 22.6118 656.979 32.7886C656.979 42.6889 648.413 51.4556 638.247 51.4556C627.842 51.4556 619.697 42.8633 619.697 32.7886Z"
          fill="#1E1A12"
        />
        <path
          d="M624.277 171.654V63.4024H651.971V171.654H624.277Z"
          fill="#1E1A12"
        />
        <path
          d="M579.391 171.654H607.605V20.1419H579.391V171.654Z"
          fill="#1E1A12"
        />
        <path
          d="M147.61 88.4229C131.69 88.4229 121.606 102.716 121.606 117.471C121.606 131.784 132.058 146.519 147.594 146.519C156.965 146.519 167.142 140.763 169.402 131.26H197.082C195.338 154.695 169.974 172.658 147.61 172.658C117.548 172.658 93.7102 146.661 93.7102 117.471C93.7102 88.2848 117.548 62.2845 147.61 62.2845C171.201 62.2845 195.818 78.8489 197.497 103.683H169.187C166.323 94.5061 157.061 88.7104 147.61 88.4229Z"
          fill="#1E1A12"
        />
        <path
          d="M78.2449 87.8675H35.4558C32.2685 87.8675 29.5824 89.8027 29.5824 93.1156C29.5824 96.4746 32.7701 97.9529 35.4558 99.2107L66.2991 114.54C78.0092 120.072 86.6568 128.117 86.6568 141.627C86.6568 158.203 72.1317 171.654 55.6143 171.654H6.08905V146.875H50.9687C54.0447 146.875 56.8421 144.816 56.8421 141.611C56.8421 137.939 53.5612 136.518 50.5539 135.3L16.7739 118.708C6.6098 113.621 0 104.528 0 93.0824C0 76.926 14.2182 63.2879 30.4286 63.2879H78.2449V87.8675Z"
          fill="#1E1A12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M396.397 172.658H396.613C426.876 172.658 450.414 146.824 450.414 117.471C450.414 88.119 426.876 62.2845 396.613 62.2845H396.397C366.228 62.2845 342.596 88.2166 342.596 117.471C342.596 146.728 366.225 172.658 396.397 172.658ZM396.613 144.849H396.397C381.652 144.849 370.552 131.515 370.552 117.471C370.552 103.43 381.653 90.0927 396.397 90.0927H396.613C411.341 90.0927 422.458 103.396 422.458 117.471C422.458 131.748 411.558 144.849 396.613 144.849Z"
          fill="#1E1A12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M458.475 117.471C458.475 88.2123 482.116 62.2845 512.284 62.2845H512.483C542.748 62.2845 566.292 88.1142 566.292 117.471C566.292 146.828 542.748 172.658 512.483 172.658H512.284C482.11 172.658 458.475 146.733 458.475 117.471ZM512.483 144.849C527.428 144.849 538.332 131.75 538.332 117.471C538.332 103.391 527.195 90.0927 512.466 90.0927H512.267C497.525 90.0927 486.418 103.428 486.418 117.471C486.418 131.517 497.522 144.849 512.267 144.849H512.483Z"
          fill="#1E1A12"
        />
        <path
          d="M760.207 62.2845C746.23 62.2845 734.81 69.3286 729.764 82.3554L707.935 137.327C707.189 140.329 704.761 143.18 701.428 143.18C698.297 143.18 695.967 140.302 695.967 137.327V63.541H668.063V142.337C668.063 158.666 681.329 172.658 698.059 172.658C712.8 172.658 724.747 165.156 729.963 151.347L750.314 97.8301C751.442 95.1289 753.249 91.7625 756.622 91.7625C759.741 91.7625 762.283 94.6013 762.283 97.6151V171.401H789.987V92.6057C789.987 76.4995 776.914 62.2845 760.207 62.2845Z"
          fill="#1E1A12"
        />
        <path
          d="M989.162 87.8675H946.356C943.169 87.8675 940.481 89.8017 940.481 93.1156C940.481 96.4694 943.672 97.9652 946.356 99.2107L977.195 114.54C988.907 120.053 997.56 128.126 997.56 141.627C997.56 158.212 983.025 171.654 966.506 171.654H916.978V146.875H961.892C964.968 146.875 967.767 144.817 967.767 141.611C967.767 137.933 964.475 136.511 961.46 135.3L927.684 118.708C917.514 113.636 910.904 104.523 910.904 93.0824C910.904 76.918 925.129 63.2879 941.344 63.2879H989.195V87.8509L989.162 87.8675Z"
          fill="#1E1A12"
        />
        <path
          d="M904.858 63.0997H904.841L875.595 62.6838L846.148 136.096C845.065 138.683 843.235 141.987 839.997 141.987C836.843 141.987 834.282 139.156 834.282 136.096V19.1387H806.109V141.155C806.109 157.6 817.991 171.654 835.137 171.654L900.618 171.655L900.618 146.413H871.667C883.06 118.78 893.798 90.8645 904.858 63.0997Z"
          fill="#1E1A12"
        />
        <path
          d="M208.596 20.1423H236.5L236.483 137.15C236.483 140.128 238.802 143.032 241.945 143.032C245.287 143.032 247.708 140.157 248.452 137.15L270.28 81.9029C275.313 68.8473 286.708 61.7315 300.724 61.7315C317.389 61.7315 330.504 75.8568 330.504 92.2047V171.395H302.799V97.2393C302.799 94.2224 300.269 91.3573 297.138 91.3573C293.758 91.3573 291.954 94.7501 290.83 97.4553L270.479 151.24C265.278 165.079 253.357 172.658 238.575 172.658C221.782 172.658 208.579 158.532 208.579 142.185L208.596 20.1423Z"
          fill="#1E1A12"
        />
      </SvgIcon>
    );
  }
  return (
    <SvgIcon viewBox="0 0 600 684" style={{ fill: fill || color }} {...props}>
      <path d="M111.467 61.3341C57.806 154.162 75.9147 281.661 161.491 350.642C212.499 391.759 261.57 435.155 311.404 477.628L258.492 537.346L258.467 537.324C218.867 503.573 107.136 409.28 107.466 409.563C-7.72 310.867 -31.1856 147.701 41.2997 22.3099L111.467 61.3341Z" />
      <path d="M435.274 43.1155L594.739 168.021L544.405 229.846L384.233 104.386L382.756 103.172C341.931 67.933 279.831 71.8619 243.784 112.041C207.898 152.04 211.854 212.859 252.687 248.235L403.478 375.817L403.779 376.074C478.047 440.18 485.565 551.068 420.088 624.05C354.732 696.898 241.68 704.271 167.274 640.047L166.961 639.775L7.9421 499.622C7.9421 499.622 61.8414 440.771 61.854 440.771L220.704 580.775C261.532 615.881 323.528 611.915 359.534 571.782C395.42 531.783 391.463 470.963 350.629 435.588L199.839 308.007L199.538 307.75C125.27 243.644 117.752 132.755 183.23 59.7732C248.361 -12.823 360.859 -20.3962 435.274 43.1155Z" />
      <path d="M488.533 623.237C542.194 530.409 524.085 402.91 438.509 333.928C387.501 292.812 288.596 206.943 288.596 206.943L341.508 147.225L341.533 147.247C381.133 180.998 492.864 275.291 492.534 275.008C607.72 373.704 631.186 536.869 558.7 662.261L488.533 623.237Z" />
    </SvgIcon>
  );
};

SchoolinksLogo.propTypes = {
  fill: string,
  color: string,
  wordmark: bool,
};

SchoolinksLogo.defaultProps = {
  fill: undefined,
  color: undefined,
  wordmark: false,
};

export default SchoolinksLogo;
